import {
    Directive,
    HostListener,
    input,
    output,
    ElementRef,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { ToastService } from '@app/core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Directive({ selector: '[appMaxFileSize]', })
export class MaxFileSizeDirective {
    /** maximum allowed size in bytes, e.g. 10 * 1024 * 1024 */
    maxSizeBytes = input.required<number>({ alias: 'appMaxFileSize' });

    filesAccepted = output<File[]>();

    constructor(
        private el: ElementRef<HTMLInputElement>,
        private ngControl: NgControl,
        private toast: ToastService,
        private translate: TranslateService
    ) {}

    @HostListener('change')
    onChange(): void {
        const input = this.el.nativeElement;
        const files = Array.from(input.files ?? []);

        const valid = files.filter(f => f.size <= this.maxSizeBytes());
        const invalid = files.filter(f => f.size > this.maxSizeBytes());

        invalid.forEach(f =>
            this.toast.error(
                `${f.name} - ${this.translate.instant('GLOBAL.FILE-TOO-LARGE')}`
            )
        );

        const dt = new DataTransfer();
        valid.forEach(f => dt.items.add(f));
        input.files = dt.files;

        this.ngControl.control?.setValue(dt.files.length ? dt.files : null);

        this.filesAccepted.emit(valid);
    }
}
